import './video.scss';
import { findAll, onBlockRender, once } from '../../global/utils/acf-preview';

// Self-hosted videos ship with a centered play button over the poster (Figma
// 268-9202). Clicking it starts playback; the overlay then hides so the native
// controls take over, and it reappears whenever the video is paused.
function initVideo( video: HTMLVideoElement ): void {
	if ( ! once( video, 'Video' ) ) {
		return;
	}
	const frame = video.closest<HTMLElement>( '.video-block__frame' );
	if ( ! frame ) {
		return;
	}

	const play = frame.querySelector<HTMLButtonElement>( '.video-block__play' );
	play?.addEventListener( 'click', () => {
		void video.play();
	} );

	video.addEventListener( 'play', () => frame.classList.add( 'is-playing' ) );
	video.addEventListener( 'pause', () => frame.classList.remove( 'is-playing' ) );
	video.addEventListener( 'ended', () => frame.classList.remove( 'is-playing' ) );
}

onBlockRender( 'video', ( root ) => {
	findAll<HTMLVideoElement>( root, '.video-block__video' ).forEach( initVideo );
} );
